
<template>
  <div class="modal_secondary">
   <!-- <div class="close" @click="hideModal()"></div>-->
    <div class="category" v-for="category in this.categories.categories" :key="category.index">
      <h1 class="category_title">{{category.name}}</h1>
      <div class="category_element" v-for="element in category.types" :key="element.index">
      <div class="category_element_container">
        <img class="category_element_thumbnail" src="https://picsum.photos/200" alt="">
        <div class="category_element_info">
        <h1 class="category_element_name">{{element}}</h1>
        <button class="category_element_link">Ver Ficha</button>
        </div>
      </div>
      <hr>
      </div>
    </div>
  </div>
</template>

<script>
import { modalHide } from '@/helpers/animations';
import data from '@/assets/db.json';

let index = 0

export default {
  name: 'ModalSecondary',
  methods:{
    hideModal: function(){
      modalHide(document.querySelector('.modal_secondary'),'secondary');
    },
    incrementIndex: function(){
      this.index=1;
    }
  },
  data(){
    return{
      categories : data,
      index: index
    }
  },
  mounted(){

  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
  .modal_secondary{
  /*position: absolute;*/
  z-index: 2;
  background-color: #2B282C;
  width:280px;
  height:30vh;
  /*height:65vh;
  left: 50%;
  top:50%;
  transform: translate(-50%,-50%) scale(0);*/
  display: flex;
  flex-direction: column;
  /*overflow: scroll;*/
}
.category{
  margin-bottom: 25px;
}
.modal_secondary>h1{
  color:#fff;
  font-family: 'cervo';
  margin-left: 15px;
}
.modal_secondary>p{
  color:#fff;
  font-family: 'garamond';
  font-size: 18px;
  padding: 15px;
}
.category_title{
  font-family: 'cervo';
  color:#fff;
  margin-left: 15px;
}
.category_element{
  display: flex;
  flex-direction: column;
}
.category_element_container{
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  padding: 15px;
}
.category_element_container>img{
  width:120px;
  height: 120px;
}
.category_element>hr{
  width: calc(100% - 30px);
  border: 1px solid #BEA58B;
  align-self: center;
}
.category_element_info{
  display: flex;
  flex-direction: column;
  justify-content: center;
  gap:10px;
}
.category_element_name{
  align-self: flex-end;
  font-family: 'garamond';
  color:#BEA58B;
}
.category_element_link{
  outline: none;
  border: 2px solid #BEA58B;
  width: 90px;
  height: 40px;
  padding-top: 5px;/*Font correction*/ 
  color:#fff;
  background-color: transparent;
  font-family: 'cervo';
  font-size: 22px;
}
</style>
